export const envWiseAppUrl = {
    'source':process.env.REACT_APP_SOURCE_APP_URL,
    'test':process.env.REACT_APP_TEST_APP_URL,
    'prod':process.env.REACT_APP_PROD_APP_URL,
}